/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FlagBIcon16Light } from './FlagBIcon16Light';
import { FlagBIcon16Regular } from './FlagBIcon16Regular';
import { FlagBIcon16Solid } from './FlagBIcon16Solid';
import { FlagBIcon20Light } from './FlagBIcon20Light';
import { FlagBIcon20Regular } from './FlagBIcon20Regular';
import { FlagBIcon20Solid } from './FlagBIcon20Solid';
import { FlagBIcon24Regular } from './FlagBIcon24Regular';
import { FlagBIcon24Solid } from './FlagBIcon24Solid';
import { FlagBIcon32Regular } from './FlagBIcon32Regular';
import { FlagBIcon64Regular } from './FlagBIcon64Regular';
var sizes = {
    16: {
        light: FlagBIcon16Light,
        regular: FlagBIcon16Regular,
        solid: FlagBIcon16Solid,
    },
    20: {
        light: FlagBIcon20Light,
        regular: FlagBIcon20Regular,
        solid: FlagBIcon20Solid,
    },
    24: {
        regular: FlagBIcon24Regular,
        solid: FlagBIcon24Solid,
    },
    32: {
        regular: FlagBIcon32Regular,
    },
    64: {
        regular: FlagBIcon64Regular,
    },
};
export var FlagBIcon = forwardRef('FlagBIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
